import { render } from "./CustomerReviews.vue?vue&type=template&id=2df72737"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__